import { ingenuity } from "@quest/base-core";
import { PlayerMsgController } from "@quest/murka-games-behavior-panther/dist";

import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants } from "@quest/slot-core/dist/SlotConstants/SlotConstants";

export class PlayerMsgControllerGame extends PlayerMsgController {
  /**
   * overrided to add basegame win amount in freegame amount
   */
  public showTotalWinMsgInFgBroken() {
    let totalFreeGameWin;
    if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      totalFreeGameWin =
        (ingenuity.parserModel as GameParserModel).getFreeSpinAccumulatedWinAmt() +
        (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt();
    } else {
      totalFreeGameWin =
        (ingenuity.parserModel as GameParserModel).getFreeSpinWinAmt() + (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt();
    }
    this.setValueInTotalWinMeter(totalFreeGameWin);
  }

  // Overrided to update base game win amount when no win in free game
  protected showTotalWinInitially() {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      this.showTotalWinMsgInFgBroken();
    }
  }
}
